// #region Imports

// Libraries
import React from 'react';
import { useField } from 'formik';
import { Button } from '@mui/material';

// #endregion

// #region Main Component

const UploadInput = (props) => {
    const { name, errorText, ...rest } = props;
    const [field, meta] = useField(props);

    return (
        <label htmlFor={name}>
            <input
                 accept=".doc,.docx,.pdf,.png,.jpg,.jpeg"
                id={name}
                type="file"
                {...field}
                {...rest}
                style={{ display: 'none' }}
            />

            <Button variant="contained" component="span" style={{ marginTop: '10px' }}>
                Upload
            </Button>
        </label>
    );
};

export default UploadInput;

// #endregion
